import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=274c43f1&scoped=true&"
import script from "./EmailDetails.vue?vue&type=script&lang=js&"
export * from "./EmailDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetails.vue?vue&type=style&index=0&id=274c43f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c43f1",
  null
  
)

export default component.exports